import React from 'react'
import Footers from '../section/Footer/Footer'
import { Outlet } from 'react-router-dom'
import Navbarr from '../section/Header/Navbar'
import ShoppingCardProvider from '../Context/ShoppingCardContext'
import './Visiteur.css'

const Visiteur = () => {
  return (
    <ShoppingCardProvider>

    <div >
      <div className="mt-0 mb-auto">
      <Navbarr/>

        <Outlet/>
      </div> 
      <Footers/>
    </div>
    </ShoppingCardProvider>
  )
}

export default Visiteur